

import { createSlice } from "@reduxjs/toolkit";
import { IPayment } from "../interface/IOrderDetails";

const initialState: IPayment[] | null = null;

const prePaymantsSlice = createSlice({
    name: "prePaymants",
    initialState,
    reducers: {
        setPrePaymantsInStore: (state: IPayment[] | null, action: any | null) => {
            return action.payload;
        },
    },
});


export const { setPrePaymantsInStore } = prePaymantsSlice.actions;

export default prePaymantsSlice.reducer;
